/***************************************************************
5/22/2017
Alexander Self
Timesheet Create
- Creates timesheets for employees; includes individual timesheet
  and gang timesheet
***************************************************************/
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addEmployeeToTimesheet, removeEmployeeFromTimesheet, addWorkToTimesheet, editWorkInTimesheet,
  removeWorkFromTimesheet, addEmployeeToGangTS, removeEmployeeFromGangTS, prepareRegTS,
  prepareGangTS, submitRegTimesheet, submitGangTimesheet, employeeAutocomplete,
  fetchSubAccounts, fetchFieldsByLoc, selectGangForTimesheet, selectGangForGangTimesheet,
  fetchBlocksByField, addNewGangInfoRow, selectCostCenterByLocation, editWorkRecord,
  addWorkToGangTimesheet, editGangWorkRecord, editGangWorkInTimesheet, deleteWorkInGangTimesheet,
  autoFillGangTimesheet
} from '../../../actions';

import { packageForm, mapEmployeeForAutoComplete, findEmployeeByName } from '../../../utils';
import EmployeeList from '../../employee_list';
import TimesheetForm from './timesheet_form';
import TimesheetIndividualModal from './timesheet_individual_modal';
import GangTimesheetForm from './timesheet_gang_form';
import { AutoComplete } from '../../inputs';
import GeneralGangList from '../../general_gang_list';
import GangFormAutoFill from './gang_autofill_form';
import React from 'react';
const $ = window.$;

/* Pass all state and actions to this component */
const TimesheetCreate = ({ user, employees, myEmployees, addedEmployees, fields, blocks, costCenters,
  details, equipmentNo, equipmentTrailerNo, subAccounts, paycodes, submitter, workPerformed,
  addedGangEmployees, empTimesheet, gangTS, payPeriodStartDate, payPeriodEndDate, prevPPStartDate,
  prevPPEndDate, gangWorkPerformed, addEmployee, removeEmployee, addWork, editWork, removeWork,
  addEmployeeToGang, removeEmployeeFromGang, prepareRegTS, prepareGangTS, submitRegTimesheet,
  submitGangTimesheet, employeeAutocomplete, fetchSubAccounts, fetchFieldsByLoc, gangs,
  selectGangForTimesheet, selectGangForGangTimesheet, fetchBlocksByField, addNewGangInfoRow,
  addedGangInfoRow, selectCostCenterByLocation, editWorkRecord, addWorkToGangTimesheet,
  editGangWorkRecord, editGangWorkInTimesheet, deleteWorkInGangTimesheet, autoFillGangTimesheet
}) => {
  $(document).ready(() => {
    $('#ts-choice').tabs();
    $('.timesheet-collapsible').collapsible();
  });
  return (
    <div className="row">
      <blockquote><span className="flow-text">Create Timesheet</span></blockquote>
      {/* INDIVIDUAL TIMEHEET */}
      <ul id="ts-choice" className="tabs tabs-fixed-width">
        <li className="tab col s6">
          <a href="#individual-ts">
            <i className="material-icons">person</i>  Individual Timesheet
          </a>
        </li>
        <li className="tab col s6">
          <a href="#gang-ts">
            <i className="material-icons">group</i>  Team Timesheet
          </a>
        </li>
      </ul>
      <div id="individual-ts">
        <div className="col s12 m12 l2 xl2">
          <ul className="collapsible timesheet-collapsible" data-collapsible="accordion">
            <li>
              <div className="collapsible-header"><i className="material-icons">person</i>Employee</div>
              <div className="collapsible-body">
                <AutoComplete id={'employee-reg-ts-list'} label={'Employee Timesheets'}
                  data={mapEmployeeForAutoComplete(employees)} onComplete={(val, id) => employeeAutocomplete(findEmployeeByName(val, employees), id)} />
                <div className="emp-list">
                  <div className="card">
                    <EmployeeList
                      employees={myEmployees}
                      icon={'person_add'}
                      header={'Add Employees'}
                      onClick={addEmployee}
                      _class={'green'}
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="collapsible-header"><i className="material-icons">group</i>Teams</div>
              <div className="collapsible-body">
                <div className="emp-list">
                  <div className="card">
                    <GeneralGangList gangs={gangs} id={'timesheet-gang-list'} onClick={selectGangForTimesheet} />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="col s12 m12 l8 xl8">
          <TimesheetForm fields={fields} blocks={blocks} details={details} workPerformed={workPerformed}
            payPeriodStartDate={payPeriodStartDate} payPeriodEndDate={payPeriodEndDate}
            prevPPStartDate={prevPPStartDate} prevPPEndDate={prevPPEndDate} user={user}
            paycodes={paycodes} addWork={addWork} editWork={editWork} removeWork={removeWork}
            costCenters={costCenters} equipmentNo={equipmentNo} equipmentTrailerNo={equipmentTrailerNo}
            subAccounts={subAccounts} fetchSubAccounts={fetchSubAccounts}
            fetchFieldsByLoc={fetchFieldsByLoc} fetchBlocksByField={fetchBlocksByField}
            selectCostCenterByLocation={selectCostCenterByLocation} editWorkRecord={editWorkRecord}
          />
        </div>
        <div className="col s12 m12 l2">
          <div className="emp-list-2">
            <div className="card">
              <EmployeeList employees={addedEmployees} icon={'clear'} _class={'red'} header={'Employees Timesheet'}
                onClick={removeEmployee} isEditOrDelete={true} />
            </div>
          </div>
          <div className="row">
            <TimesheetIndividualModal id={'individual-ts-modal'}
              timesheet={empTimesheet} employees={addedEmployees}
              workPerformed={workPerformed} submitRegTimesheet={submitRegTimesheet}
              payPeriodStartDate={payPeriodStartDate} payPeriodEndDate={payPeriodEndDate}
              prevPPStartDate={prevPPStartDate} prevPPEndDate={prevPPEndDate}
              user={user}
            />
            <div className="col s12">
              <button data-target="individual-ts-modal"
                className="btn waves-light waves-effect"
                onClick={() => prepareRegTS(packageForm('basic-ts-form'), workPerformed, submitter)}>
                Prepare
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* GANG TIMEHEET */}
      <div className="col s12" id="gang-ts">
        <div className="col s12 m12 l2">
          <ul className="collapsible timesheet-collapsible" data-collapsible="accordion">
            <li>
              <div className="collapsible-header"><i className="material-icons">person</i>Employee</div>
              <div className="collapsible-body">
                <AutoComplete id={'employee-gang-ts-list'} label={'Find Employee'}
                  data={mapEmployeeForAutoComplete(employees)} onComplete={(val, id) => employeeAutocomplete(findEmployeeByName(val, employees), id)} />
                <div className="emp-list">
                  <div className="card">
                    <EmployeeList employees={myEmployees} icon={'person_add'} header={'Add Employees'} onClick={addEmployeeToGang} _class={'green'} />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="collapsible-header"><i className="material-icons">group</i>Teams</div>
              <div className="collapsible-body">
                <div className="emp-list">
                  <div className="card">
                    <GeneralGangList gangs={gangs} id={'timesheet-gang-list2'} onClick={selectGangForGangTimesheet} />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="collapsible-header"><i className="material-icons">cached</i>Form Auto-Fill</div>
              <div className="collapsible-body">
                <div>
                  <div className="card">
                    <GangFormAutoFill fields={fields} blocks={blocks} autoFillGangTimesheet={autoFillGangTimesheet}
                      fetchBlocksByField={fetchBlocksByField} />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="col s12 m12 l10">
          <div className="row">
            <GangTimesheetForm
              addedGangEmployees={addedGangEmployees} addEmployeeToGang={addEmployeeToGang}
              removeEmployeeFromGang={removeEmployeeFromGang} prepareGangTS={prepareGangTS}
              submitter={submitter} gangTS={gangTS} submitGangTimesheet={submitGangTimesheet}
              payPeriodStartDate={payPeriodStartDate} payPeriodEndDate={payPeriodEndDate}
              prevPPStartDate={prevPPStartDate} prevPPEndDate={prevPPEndDate}
              fields={fields} blocks={blocks} paycodes={paycodes}
              fetchFieldsByLoc={fetchFieldsByLoc} fetchBlocksByField={fetchBlocksByField}
              addNewGangInfoRow={addNewGangInfoRow} addedGangInfoRow={addedGangInfoRow}
              fetchSubAccounts={fetchSubAccounts} costCenters={costCenters}
              subAccounts={subAccounts} addWorkToGangTimesheet={addWorkToGangTimesheet}
              gangWorkPerformed={gangWorkPerformed} editGangWorkRecord={editGangWorkRecord}
              editGangWorkInTimesheet={editGangWorkInTimesheet} deleteWorkInGangTimesheet={deleteWorkInGangTimesheet}
              selectCostCenterByLocation={selectCostCenterByLocation} user={user}
            />
          </div>
        </div>
      </div>
    </div>
  );
};


function mapStateToProps(state) {
  return {
    addedEmployees: state.timesheet.addedEmployees,
    addedGangEmployees: state.timesheet.gangTS.addedGangEmployees,
    addedGangInfoRow: state.timesheet.gangTS.addedGangInfoRow,
    blocks: state.timesheet.blocks,
    costCenters: state.timesheet.costCenters.displaying,
    details: state.timesheet.details.displaying,
    employees: state.timesheet.employees,
    empTimesheet: state.timesheet.employeeTS,
    equipmentNo: state.equipment.equipmentNo,
    equipmentTrailerNo: state.equipment.equipmentTrailerNo,
    fields: state.timesheet.fields,
    gangs: state.gang.gangs,
    gangTS: state.timesheet.gangTS.timesheet,
    gangWorkPerformed: state.timesheet.gangTS.gangWorkPerformed,
    myEmployees: state.timesheet.myEmployees,
    paycodes: state.timesheet.paycodes,
    payPeriodStartDate: state.misc.payPeriod.startDate,
    payPeriodEndDate: state.misc.payPeriod.endDate,
    prevPPStartDate: state.misc.prevPP.startDate,
    prevPPEndDate: state.misc.prevPP.endDate,
    subAccounts: state.timesheet.subAccounts,
    submitter: state.auth.user.guid,
    user: state.auth.user,
    workPerformed: state.timesheet.employeeTS.secondaryTS.workPerformed,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addEmployee: addEmployeeToTimesheet,
    removeEmployee: removeEmployeeFromTimesheet,
    addWork: addWorkToTimesheet,
    editWork: editWorkInTimesheet,
    removeWork: removeWorkFromTimesheet,
    addEmployeeToGang: addEmployeeToGangTS,
    removeEmployeeFromGang: removeEmployeeFromGangTS,
    submitRegTimesheet: submitRegTimesheet,
    submitGangTimesheet: submitGangTimesheet,
    employeeAutocomplete,
    editWorkRecord,
    fetchFieldsByLoc,
    fetchSubAccounts,
    fetchBlocksByField,
    selectGangForTimesheet,
    selectGangForGangTimesheet,
    addNewGangInfoRow,
    selectCostCenterByLocation,
    addWorkToGangTimesheet,
    editGangWorkRecord,
    editGangWorkInTimesheet,
    deleteWorkInGangTimesheet,
    autoFillGangTimesheet,
    prepareRegTS,
    prepareGangTS
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetCreate);



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_create.js